var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgCertificate = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 12H10V13.5H5.5V12Z",
    fill: "white",
    fillOpacity: 0.54
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 9H13V10.5H5.5V9Z",
    fill: "white",
    fillOpacity: 0.54
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 6H13V7.5H5.5V6Z",
    fill: "white",
    fillOpacity: 0.54
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 19.5H3V4.5H21V12H22.5V4.5C22.5 4.10218 22.342 3.72064 22.0607 3.43934C21.7794 3.15804 21.3978 3 21 3H3C2.60218 3 2.22064 3.15804 1.93934 3.43934C1.65804 3.72064 1.5 4.10218 1.5 4.5V19.5C1.5 19.8978 1.65804 20.2794 1.93934 20.5607C2.22064 20.842 2.60218 21 3 21H10.5V19.5Z",
    fill: "white",
    fillOpacity: 0.54
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6 19.5V19.4H10.5H3.1V4.6H20.9V12V12.1H21H22.5H22.6V12V4.5C22.6 4.07565 22.4314 3.66869 22.1314 3.36863C21.8313 3.06857 21.4243 2.9 21 2.9H3C2.57565 2.9 2.16869 3.06857 1.86863 3.36863C1.56857 3.66869 1.4 4.07565 1.4 4.5V19.5C1.4 19.9243 1.56857 20.3313 1.86863 20.6314C2.16869 20.9314 2.57565 21.1 3 21.1H10.5H10.6V21V19.5Z",
    stroke: "white",
    strokeOpacity: 0.54,
    strokeWidth: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 19.1925L14.5575 17.25L13.5 18.3075L16.5 21.3075L22.5 15.3075L21.4425 14.25L16.5 19.1925Z",
    fill: "white",
    fillOpacity: 0.54
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 19.0511L14.6282 17.1793L14.5575 17.1086L14.4868 17.1793L13.4293 18.2368L13.3586 18.3075L13.4293 18.3782L16.4293 21.3782L16.5 21.4489L16.5707 21.3782L22.5707 15.3782L22.6414 15.3075L22.5707 15.2368L21.5132 14.1793L21.4425 14.1086L21.3718 14.1793L16.5 19.0511Z",
    stroke: "white",
    strokeOpacity: 0.54,
    strokeWidth: 0.2
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCertificate, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/certificate.671012a6.svg";
export { ForwardRef as ReactComponent };